import type {
    SettingsCompanyInformation,
    SettingsCompanyInformationItemWithVisibility,
    SettingsCompanyInformationWithVisibility,
} from '../types/company';

export type ContactPrioritySetting = (typeof ContactPrioritySetting)[keyof typeof ContactPrioritySetting];
export const ContactPrioritySetting = {
    PRIMARY: 'PRIMARY',
    OTHER: 'OTHER',
} as const;

export type ContactVisibilitySetting = (typeof ContactVisibilitySetting)[keyof typeof ContactVisibilitySetting];
export const ContactVisibilitySetting = {
    PUBLISHED: 'PUBLISHED',
    HIDDEN: 'HIDDEN',
} as const;

/*
 * Нормализует телефоны/почты, добавляя дефолтные priority и visibility если их нет.
 * Первый элемент: PRIMARY + PUBLISHED, остальные: OTHER + HIDDEN
 */
export function normalizeContactSettings(
    items: SettingsCompanyInformation | SettingsCompanyInformationWithVisibility | undefined
): SettingsCompanyInformationWithVisibility {
    if (!items || items.length === 0) {
        return [];
    }

    return items.map((item, index): SettingsCompanyInformationItemWithVisibility => {
        // Если поля уже есть, оставляем как есть
        if ('priority' in item && 'visibility' in item && item.priority && item.visibility) {
            return item as SettingsCompanyInformationItemWithVisibility;
        }

        // Иначе проставляем дефолтные значения
        return {
            name: item.name,
            value: item.value,
            priority: index === 0 ? ContactPrioritySetting.PRIMARY : ContactPrioritySetting.OTHER,
            visibility: index === 0 ? ContactVisibilitySetting.PUBLISHED : ContactVisibilitySetting.HIDDEN,
        };
    });
}
